import { Tabs, Tab } from '@mui/material';
import { isSuperAdmin } from '../../../utils/role';

type Props = {
    selectedTab: number;  
    handleTabChange: (event: React.SyntheticEvent, newValue: number) => void;  
}

const ExternalInfoNavbar = ({
    selectedTab,
    handleTabChange,
}: Props) => {

    return (
        <>
            <Tabs
                value={selectedTab}
                onChange={handleTabChange}
                aria-label="External Info Tab"
                sx={{ marginRight: "auto" }}
            >
                <Tab sx={{fontSize: 'small'}} label="Emails" />
                {isSuperAdmin()&&<Tab sx={{fontSize: 'small'}} label="Notifications" />}
            </Tabs>
        </>
    )
}

export default ExternalInfoNavbar